module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/covid_measures/3_b9a1c2091c576fed4813e1a1daa128a4.png";